export const formatRateUsSubmittedHeading = (heading: string) =>
  heading.trim().replace(/\s*!+$/, "");
